import { styled, IconButton, Divider } from '@mui/material'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { colorPalette } from '../../../style/colorPalette'

const CloseIconButton = styled(IconButton)({
  width: '24px',
  height: '24px',
  padding: '4px',
  color: colorPalette.monotone[4],
  '&:hover': {
    backgroundColor: colorPalette.monotone[1],
  },
})

const CloseIcon = styled(CloseRoundedIcon)({
  fontSize: '16px',
})

interface CloseButtonProps {
  onClick: () => void
}

export const CloseButton = ({ onClick }: CloseButtonProps) => (
  <CloseIconButton onClick={onClick}>
    <CloseIcon />
  </CloseIconButton>
)

export const StyledDivider = styled(Divider)({
  margin: '0 16px',
  borderColor: colorPalette.monotone[2],
})

export const PlaceholderText = styled('span')({
  color: colorPalette.monotone[4],
})
